import React from 'react';
import LoadingButton from '../button/LoadingButton/LoadingButton';
import { t } from 'i18next';

interface UserTableProps {
  title: string;
  users: IUser[];
  organizer: boolean;
  submitStatus: Record<string, "idle" | "submitting" | "submitted">;
  onResendEmail: (user: IUser) => void;
}

const UserTable: React.FC<UserTableProps> = ({
  title,
  users,
  organizer,
  submitStatus,
  onResendEmail
}) => {
  if (users.length === 0) {
    return (
      <>
        <h5 className="my-2 fw-bold">{title}</h5>
        <div className="alert alert-light" role="alert">
          Nenhum {title.toLowerCase()} cadastrado
        </div>
      </>
    );
  }

  return (
    <>
      <h5 className="my-2 fw-bold">{title}</h5>
      <div className="card w-100 pt-4 px-4 mb-4">
        <table style={{tableLayout: 'fixed', width: '100%'}}>
          <thead>
            <tr className='border-bottom'>
              <th scope="col" className='pb-4' style={{width: '25%'}}>
                <strong>{t("personData.name")}</strong>
              </th>
              <th scope="col" className='pb-4' style={{width: '35%'}}>
                <strong>{t("personData.email")}</strong>
              </th>
              {organizer && (
                <>
                  <th scope="col" className='pb-4' style={{width: '20%'}}>
                    <strong>{t("personData.status")}</strong>
                  </th>
                  <th scope="col" className='pb-4' style={{width: '20%'}}></th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr
                className={index < users.length - 1 ? 'border-bottom' : ''}
                key={user.email}
              >
                {(organizer || user.name) && (
                  <>
                    <td className="py-4">{user.name || "-"}</td>
                    <td className="py-4">{user.email}</td>
                  </>
                )}
                {organizer && (
                  <>
                    <td className='py-4'>
                      {user.confirmed_at ? t("feedbackList.status.confirmed") : t("feedbackList.status.pending")}
                    </td>
                    <td className="text-end py-1">
                      {!user.confirmed_at && (
                        <LoadingButton
                          status={submitStatus[user.id] || "idle"}
                          idleText={t("buttonActions.resendEmail")}
                          submittedText={t("buttonActions.emailResent")}
                          onClick={() => onResendEmail(user)}
                          className="btn btn-sm btn-primary"
                        />
                      )}
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default UserTable;
